
import { Component, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'

@Component({
  components: {
    BacModal,
    BacButton
  }
})
export default class WaitingForDownloadModal extends Vue {
}
